import {
  Autocomplete,
  Box,
  Button,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { sxAutocomplete, sxButton, sxModal, sxOutlinedButton } from "./sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { CitiesListModalProps } from "../../../interfaces/props/SaudeOnline/CitiesListModalProps";
import { City } from "../../../interfaces/entities/City";
import "./styles.css";
import { useState } from "react";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function CitiesListModal(props: CitiesListModalProps) {
  const [city, setCity] = useState<City | null>(null);

  const { fontSizeStyleAccessibility } = useAccessibility();

  const handleChange = (event: React.SyntheticEvent, value: City | null) => {
    setCity(value);
  };

  return (
    <div className="confirmation-modal-holder">
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxModal}>
          <div className="confirmation-modal-header">
            <h1
              className="confirmation-modal-header-title"
              style={fontSizeStyleAccessibility}
            >
              Localização dentro da área de cobertura
            </h1>
            <button
              className="confirmation-modal-header-close"
              onClick={props.handleClose}
              aria-label="fechar"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="confirmation-modal-info">
            <h1 className="hour-title" style={fontSizeStyleAccessibility}>
              Selecione a cidade
            </h1>
            <label htmlFor="combo-box-demo" aria-label="selecione a cidade para poder confirmar" />
            <Autocomplete
              disablePortal
              fullWidth
              id="combo-box-demo"
              onChange={handleChange}
              options={props.closeCities}
              value={city}
              getOptionLabel={(option: City) => option.descr}
              sx={sxAutocomplete}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="confirmation-modal-buttons cities-list-modal-buttons">
            <div className="cities-list-button">
              <Button
                variant="outlined"
                onClick={props.handleClose}
                sx={sxOutlinedButton}
                disabled={false}
                style={fontSizeStyleAccessibility}
                fullWidth
              >
                <Typography style={{ color: "#00995D" }}>Cancelar</Typography>
              </Button>
            </div>
            <div className="cities-list-button">
              <Button
                variant="contained"
                sx={sxButton}
                style={fontSizeStyleAccessibility}
                onClick={() => props.handleCity(city)}
                disabled={city === null}
                fullWidth
              >
                Confirmar
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default CitiesListModal;
